import { int64 } from '@fullstory/proto/google/protobuf';

export function userSessionId(userId: int64, sessionId: int64) {
  return `${userId}!${sessionId}`;
}
